   
    
//*============================================================================    
// 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B 75B    
//*============================================================================*/
 $(document).ready(function(){  	
 var colors = [
 '#81c391',
  '#21201c',
  '#f9d1a4',
  '#ec6661',
  '#c2ad99',
  '#e2c100',
  '#ec6661',
  '#81c391',
  '#21201c',
  '#f9d1a4',
  '#767651',
  '#ec6661',
  '#c2ad99',
  '#f9d1a4',
  '#e2c100',
  '#21201c',
  '#1ea6bf',
  '#f9d1a4',
  '#81c391',
  '#e2c100',
  '#21201c',
  '#ec6661',
  '#006c60',
  '#768175',
  '#bc9275',
  '#bc9275',
  '#21201c',
  '#768175',
  '#bc9275',
  '#bc9275',
  '#bc9275',
  '#bc9275',
  '#254c59',
  '#6199af',
  '#c57d59',
  '#8c3b44',
  '#9daeab',
  '#6199af',
  '#8c3b44',
  '#afcab9',
  '#f3d2a4',
  '#254c59',
  '#21201c',
  '#254c59',
  '#afcab9',
  '#6199af',
  '#9daeab',
  '#8c3b44',
  '#c57d59',
  '#6199af',
  '#8c3b44',
  '#afcab9',
// nieuw
  '#00ff44',
  '#ee00ff',
  '#00e5ff',
  '#ff0000',
  '#fb7a32',
  '#ddf595',
 ];
    
   

  colors = colors.sort(() => Math.random() - 0.5)
    col_counter = 0;

  function colorize( ) {
   if (colors.length < col_counter){
     col_counter = 0;
   }
  
    $('.color-1').css('fill',colors[col_counter]).css('color',colors[col_counter]); 
    $('.newsletter__wrapper').css('background-color',colors[col_counter]);
    $('.color-2').css('fill',colors[col_counter+1]).css('color',colors[col_counter + 1]); 
    col_counter++;
    
    setTimeout(function(){
      colorize();
    },6000);
  }

  colorize();
    
});